/**
 * API Configuration and utilities
 */

const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_URL || 'https://m1wfhwazrd.execute-api.us-east-1.amazonaws.com/prod',
  stage: import.meta.env.VITE_API_STAGE || '',
  timeout: 10000,
};

/**
 * Build API endpoint URL
 */
export const buildApiUrl = (endpoint) => {
  // Since baseURL already includes /prod, we don't need to add stage
  return `${API_CONFIG.baseURL}${endpoint}`;
};

/**
 * Generic API request handler
 */
export const apiRequest = async (endpoint, options = {}) => {
  const url = buildApiUrl(endpoint);
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_CONFIG.timeout);
    
    const response = await fetch(url, {
      ...config,
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { success: true, data };
    
  } catch (error) {
    console.error('API Request failed:', error);
    
    if (error.name === 'AbortError') {
      throw new Error('Request timeout');
    }
    
    throw error;
  }
};

/**
 * Submit lead registration
 */
export const submitLead = async (leadData) => {
  return apiRequest('/submit', {
    method: 'POST',
    body: JSON.stringify(leadData),
  });
};

/**
 * Health check endpoint
 */
export const healthCheck = async () => {
  return apiRequest('/health');
};